import { render, staticRenderFns } from "./Process-1.vue?vue&type=template&id=4e7b8880&scoped=true&"
import script from "./Process-1.vue?vue&type=script&lang=js&"
export * from "./Process-1.vue?vue&type=script&lang=js&"
import style0 from "./Process-1.vue?vue&type=style&index=0&id=4e7b8880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b8880",
  null
  
)

export default component.exports